<div class="main-section">


    <div class="council-section">
    
      <div class="council-text">
  
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="council-name">
                {{lgElectionService.currentCouncil?.councilFullName}}
              </div>
            </mat-panel-title>
       
          </mat-expansion-panel-header>
          <div class="council-logo" *ngIf="lgElectionService.currentCouncil"> 
            <img class="council-logo-img" [src]="lgElectionService.currentCouncil.coucilLogoURL" alt="logo">
          </div>
          At the close of nominations at 12 noon on {{lgElectionService.currentCouncil?.nominationsClose | date: 'EEEE d MMMM yyyy'}}, the following nominations were received and accepted for 
          this election. In accordance with the <i><b>Local Government (Elections) Act 1999</b></i>, a draw was held to determine the order 
          of candidate names to appear on the ballot paper. The result of the draw and profiles of each of the candidates are printed 
          below. This information is provided by the candidate and neither the returning officer nor {{lgElectionService.currentCouncil?.councilFullName}} takes responsibility 
          or bears liability for the information contained within.
        </mat-expansion-panel>
      </div>
    </div>
    
    <mat-tab-group [selectedIndex]="lgElectionService.currentCouncil?.selectedElection" >
      <mat-tab 
        *ngFor="let election of lgElectionService.currentCouncil?.elections; let index = index" 
        [label]="election.electionName">
        <div>
          <div class="election-line">
            <b>{{election.electionLine}}</b>
          </div>

          
          <div *ngIf="election.electionStatus===LGEElectionStatusEnum.notPublic" class="section-result">
            <div class="no-election-required">
              No candidate profiles have been made public at this time.
            </div>
          </div>
          
          <div *ngIf="election.electionStatus===LGEElectionStatusEnum.nonElection" class="section-result">
            <div class="no-election-required" *ngIf="election.candidateCount===1">
              At the close of nominations at 12 noon on {{lgElectionService.currentCouncil?.nominationsClose | date: 'EEEE d MMMM yyyy'}}, the number 
              of candidates was not more than the number of vacancies and the following person was duly elected.
            </div>
            <div class="no-election-required" *ngIf="election.candidateCount!==1">
              At the close of nominations at 12 noon on {{lgElectionService.currentCouncil?.nominationsClose | date: 'EEEE d MMMM yyyy'}}, the number of candidates was not 
              more than the number of vacancies and the following people were duly elected.
            </div>
            <!-- <div *ngFor="let candidate of election?.candidates" class="candidate-elected-section">
              <div class="candidate-elected">{{candidate.candidateName}}</div> 
              <div class="candidate-elected-text">
                Elected
              </div>
            </div> -->
          </div>

          <div *ngIf="election.electionStatus===LGEElectionStatusEnum.requiresSupElection" class="section-result">
            <div class="no-election-required" *ngIf="election.candidateCount===0">
              At the close of nominations at 12 noon on {{lgElectionService.currentCouncil?.nominationsClose | date: 'EEEE d MMMM yyyy'}}, no nominations were received. A supplementary election will 
              be held for the {{election.unfilled}} unfilled vacanc{{election.unfilled===1 ?'y':'ies'}}.
            </div>
            <div class="no-election-required" *ngIf="election.candidateCount!==0">
              At the close of nominations at 12 noon on {{lgElectionService.currentCouncil?.nominationsClose | date: 'EEEE d MMMM yyyy'}}, the number of candidates was not more than the 
              number of vacancies and the following people were duly elected. A supplementary election will be held for the {{election.unfilled}} 
              unfilled vacanc{{election.unfilled===1 ?'y':'ies'}}.
            </div>
            <!-- <div *ngFor="let candidate of election?.candidates" class="candidate-elected-section">
              <div class="candidate-elected">{{candidate.candidateName}} &nbsp;&nbsp; (Elected)</div> 
            </div> -->
          </div>

          <div *ngIf="election.electionStatus!==LGEElectionStatusEnum.notPublic" class="section-result">
            <mat-accordion>
              <mat-expansion-panel
                class="detail-expansion-panel"
                *ngFor="let candidate of election?.candidates"
                [(expanded)]="candidate.expand" (opened)="loadImageFromBlob(candidate);">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <mat-icon style="margin-right: 8px;">
                      person
                    </mat-icon>
                    <span >
                      <b>{{candidate.candidateName}}</b>
                    </span>
                    <mat-icon style="margin-right: 20px;" *ngIf="candidate.documentCount > 0">
                      task
                    </mat-icon>
                    <span *ngIf="candidate.documentCount > 0">{{candidate.documentCount}}</span>
                    <span >
                      <b>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
                        {{election.electionStatus===LGEElectionStatusEnum.requiresSupElection ||
                          election.electionStatus===LGEElectionStatusEnum.nonElection ? 'Elected' : ''}}
                          {{(election.electionResultStatus===LGEResultsStatusEnum.declaration || election.electionResultStatus===LGEResultsStatusEnum.final) && candidate.isElected ? 'Elected' : ''}}
                      </b>
                    </span>
                  </mat-panel-title>
  
                </mat-expansion-panel-header>
                <div class="profile-card">
                    <div>
                        <img [src]="candidate.imageSource" 
                          alt="Photo" 
                          class="image" 
                          height="250px"
                          onContextMenu="return false;"
                          [style.filter]="'grayscale(' + candidate.websiteGrayScale + ') sepia(' + candidate.websiteSepia + ') brightness(' + candidate.websiteBrightness + '%)'"/>
                    </div>
                    <div>
                         <div class="profile-text">
                            {{candidate.candidateProfileText}}
                        </div>
                        <div class="extra-text">
                            {{candidate.candidateLiveInTheArea}}
                        </div>
                        <div class="extra-text">
                            {{candidate.candidateContactDetails}}
                        </div>
                        <div class="extra-text">
                            {{candidate.candidateParty}}
                        </div>
                    </div>
                    
                    <div class="candidate-documents" *ngIf="candidate.documentCount > 0">
                      <div *ngFor="let document of candidate.documents" class="candidate-document-item">
                        <button mat-mini-fab 
                          color="primary" 
                          aria-label="Document"
                          (click)="openDocument(document);">
                          <mat-icon>task</mat-icon>
                        </button>
                        <div class="candidate-document-item-text">
                          {{document.documentDescription}}
                        </div>
                      </div>
                    </div>

                </div>
              </mat-expansion-panel>
            </mat-accordion>
          </div>

          <app-lge-election-results 
          [election]="election" 
          *ngIf="election.hasResults">
        </app-lge-election-results>

        <div *ngIf="lgElectionService.currentCouncil?.councilCode==='COO'" class="section-result">
          <div class="no-election-required2">
            The Local Government (Defaulting Council) Amendment Bill 2022 was recently passed to extend the administration period for the District Council of 
            Coober Pedy for a further 4 years.
            <br /><br />
            Therefore, the periodic election in the District Council of Coober Pedy will cease to be held in November 2022.
            <!-- It should be noted that the Hon Geoff Brock MP, Minister for Local Government, has introduced the Local Government (Defaulting Council) 
            Amendment Bill 2022 (the Amendment Bill) to extend the administration of the council.<br /><br />
            If passed, the Amendment Bill will extend the period of administration at the council to a maximum further 4 years. To do this, the 
            Bill will also cause the election to cease to be held. -->
          </div>
        </div>

        </div>
      </mat-tab>
    </mat-tab-group>
  </div>